import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";
import { themeSettings } from "theme";
import Layout from "pages/layout";
import Login from "pages/login";
import Dashboard from "pages/dashboard";
import Products from "pages/products";
import Customers from "pages/customers";
import Transactions from "pages/transactions";
import Geography from "pages/geography";
import Overview from "pages/overview";
import Daily from "pages/daily";
import Monthly from "pages/monthly";
import Breakdown from "pages/breakdown";
import Admin from "pages/admin";
import Performance from "pages/performance";
import Pos from "pages/pos";
import Category from "pages/category";
import SubCategory from "pages/subcategory";
import SubSubCategory from "pages/subsubcategory";
import BrandSetup from "pages/brand";
import BrandList from "pages/brandlist";
import ProductList from "pages/productlist";
import AddNewProduct from "pages/addnewproduct";
import BulkImport from "pages/bulkimport";
import RequestRestockList from "pages/requestrestocklist";
import SendNotification from "pages/sendnotification";
import PushNotificationSetup from "pages/pushnotificationsetup";
import OrdersPage from "pages/orders";
import OrderDetails from "pages/orders/orderdetails";
import Reports from "pages/reports";
import RefundRequests from "pages/refundrequest";
import BarCode from "pages/barcode";
import Support  from "pages/supportticket";
import Messages from "pages/messages";
import Inbox  from "pages/inbox";
import ProductReport from "pages/productreports";
import SalesReport from "pages/salesreports";
import InHouseShop from "pages/inhouseshop";
import BussinessSetup from "pages/bussinesssetup";
import SystemSetup from "pages/systemsetup";
import SEOSettings from "pages/seo";
import PaymentGateways from "pages/3rdparty";
import ChatBox from "pages/chatbox";
import PricingTable from "pages/pricing";

// import Team from "pages/team";

// Guard: routes below require a stored auth token, otherwise redirect to login.
const RequireAuth = () => {
  const token = useSelector((state) => state.global.token) || localStorage.getItem("token");
  return token ? <Outlet /> : <Navigate to="/login" replace />;
};

function App() {
  const mode = useSelector((state) => state.global.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Login />} />
            <Route element={<RequireAuth />}>
            <Route element={<Layout />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/pos" element={<Pos />} />
              <Route path="/products" element={<Products />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/transactions" element={<Transactions />} />
              <Route path="/geography" element={<Geography />} />
              <Route path="/overview" element={<Overview />} />
              <Route path="/daily" element={<Daily />} />
              <Route path="/monthly" element={<Monthly />} />
              <Route path="/breakdown" element={<Breakdown />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/performance" element={<Performance />} />
              <Route path="/categories" element={<Category />} />
              <Route path="/subcategories" element={<SubCategory />} />
              <Route path="/subsubcategories" element={<SubSubCategory />} />
              <Route path="/brands/add-new" element={<BrandSetup />} />
              <Route path="/brands/list" element={<BrandList />} />
              <Route path="/products/list" element={<ProductList />} />
              <Route path="/products/add-new" element={<AddNewProduct />} />
              <Route path="/products/bulk-import" element={<BulkImport />} />
              <Route path="/products/request-restock-list" element={<RequestRestockList />} />
              <Route path="/products/barcode/:productid" element={<BarCode />} />
              <Route path="/send-notification" element={<SendNotification />} />
              <Route path="/orders" element={<OrdersPage />} />
              {/* Legacy per-status order routes now redirect into the unified page */}
              <Route path="/orders/all" element={<Navigate to="/orders" replace />} />
              <Route path="/orders/pending" element={<Navigate to="/orders" replace />} />
              <Route path="/orders/delivered" element={<Navigate to="/orders" replace />} />
              <Route path="/orders/confirmed" element={<Navigate to="/orders" replace />} />
              <Route path="/orders/order-details" element={<OrderDetails />} />
              <Route path="/reports" element={<Reports />} />
              {/* Legacy report routes now resolve to the unified Reports page */}
              <Route path="/order-reports" element={<Navigate to="/reports" replace />} />
              <Route path="/OrderReports" element={<Navigate to="/reports" replace />} />
              <Route path="/refund-requests" element={<RefundRequests/>} />
              <Route path="/Support-Ticket" element={<Support />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/inbox" element={<Inbox />} />
              <Route path="/product-reports" element={<ProductReport />} />
              <Route path="/sales-reports" element={<SalesReport />} />
              <Route path="/system/bussiness-settings" element={<BussinessSetup />} />
              <Route path="/system/in-house-shop" element={<InHouseShop />} />
              <Route path="/system/seo-settings" element={<SEOSettings />} />
              <Route path="/system-setup" element={<SystemSetup />} />
              <Route path="/push-notification-setup" element={<PushNotificationSetup />} />
              <Route path="/third-party" element={<PaymentGateways />} />
              <Route path="/chatbox" element={<ChatBox />} />
              <Route path="/pricing" element={<PricingTable />} />
              
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Route>
            </Route>
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
